var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6V3.75C7.25 2.7835 8.0335 2 9 2H15C15.9665 2 16.75 2.7835 16.75 3.75V6H20C21.1046 6 22 6.89543 22 8V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V8C2 6.89543 2.89543 6 4 6H7.25ZM8.75 3.75V6H15.25V3.75C15.25 3.61193 15.1381 3.5 15 3.5H9C8.86193 3.5 8.75 3.61193 8.75 3.75ZM13.7143 15.9904C13.7143 15.4968 14.0197 15.0629 14.4252 14.771C15.3824 14.0819 16 12.9947 16 11.7715C16 9.68857 14.2091 8 12 8C9.79086 8 8 9.68857 8 11.7715C8 12.9947 8.61757 14.0819 9.57476 14.771C9.98026 15.0629 10.2857 15.4968 10.2857 15.9904C10.2857 16.3385 10.5732 16.6207 10.9278 16.6207H13.0722C13.4268 16.6207 13.7143 16.3385 13.7143 15.9904ZM10.1574 18.3131C10.1574 18.6925 10.4707 19 10.8571 19H13.1429C13.5293 19 13.8426 18.6925 13.8426 18.3131C13.8426 17.9338 13.5293 17.6262 13.1429 17.6262H10.8571C10.4707 17.6262 10.1574 17.9338 10.1574 18.3131Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaBriefcase);
export default __webpack_public_path__ + "static/media/idea-briefcase.159f2f5d7eeb2aa8f8a0ab5bc4263109.svg";
export { ForwardRef as ReactComponent };